import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Global } from '../../Variables/Global';
import axiosInstance from '../../api/axiosConfig';
import { Button, Modal } from 'react-bootstrap';

const SelectCompany = (props) => {

    const [selectedCompany, setSelectedCompany] = useState(0)
    const [userPhoneNumber, setUserPhoneNumber] = useState(0)

    const [companies, setCompanies] = useState([]);
    const [user, setUser] = useState("");
    const navigate = useNavigate();

    const [showOTPModal, setShowOTPModal] = useState(false);
    const handleCloseShowOTPModal = () => setShowOTPModal(false);
    const [otp, setOtp] = useState('');
    const [otpSent, setOtpSent] = useState(false);

    const handleOTPChange = (e) => {
        const otpValue = e.target.value;
        setOtp(otpValue);
    };

    const GetAssignedComapnies = (userId) => {

        const body = {
            UserId: userId,
        }

        var config = {
            method: 'post',
            url: "Token/GetCompaniesforUser",
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
            data: body
        };

        axiosInstance(config)
            .then(function (response) {
                setCompanies(response.data.data.companies);
                setUserPhoneNumber(response.data.data.mobileNumber);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const GetUser = (userId) => {
        var config = {
            method: 'get',
            url: 'User/GetUser/' + userId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            }
        };
        axiosInstance(config)
            .then(function (response) {
                if (response.status === 200) {
                    setUser(() => response.data);

                }
            })
            .catch(function (error) {
                toast.error(error)
            });
    }

    const SendOTP = () => {
        const data = {
            userId: localStorage.getItem("uTsReD"),
        };
        var config = {
            method: 'post',
            url: 'token/SendOTP',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
            data: data
        };
        axiosInstance(config)
            .then(function (response) {
                if (response.status === 200) {
                    setShowOTPModal(true);
                }
            })
            .catch(function (error) {
                toast.error(error.response.data)
            });
    }

    const Selected = () => {
        if (selectedCompany !== 0) {

            const body = {
                CompanyId: selectedCompany,
                UserId: localStorage.getItem("uTsReD"),
                OTP: otp
            }
            var config = {
                method: 'post',
                url: "Token/AssignCompanyToUser",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': Global.Host
                },
                data: body
            };

            axiosInstance(config)
                .then(function (response) {
                    if (response.status === 200) {
                        if (response.data.data.user.changePassword == true) {
                            navigate("/setnewpassword/" + response.data.data.user.userId);
                        }
                        else {
                            localStorage.setItem("C0m8N!", selectedCompany)
                            localStorage.setItem("token", response.data.data.token);
                            localStorage.setItem("uTsReD", response.data.data.user.userId);
                            localStorage.setItem("Def@ult$creeN", response.data.data.user.defaultScreenId)
                            sessionStorage.setItem('screenReloded', 'false');
                            sessionStorage.setItem('sessionExpired', 'false');
                            props.setCompanyId(selectedCompany);
                            navigate("/");
                        }
                    }
                })
                .catch(function (error) {
                    toast.error(error)
                });
        }

    }

    useEffect(() => {
        var userId = localStorage.getItem("uTsReD");
        GetAssignedComapnies(userId);
        GetUser(userId);

        if (companies.length === 1) {
            setSelectedCompany(companies[0].companyId);
            if (companies[0].isOTPRequired && !otpSent) {
                SendOTP();
                setOtpSent(true);  // Mark OTP as sent
            } else if (!otpSent) {
                Selected();  // Automatically trigger the Go function
            }
        } else if (selectedCompany !== 0) {
            const selectedCompanyData = companies.find(company => company.companyId == selectedCompany);

            if (selectedCompanyData && selectedCompanyData.isOTPRequired && !otpSent) {
                SendOTP();
                setOtpSent(true);  // Mark OTP as sent
            } else if (!otpSent) {
                Selected();  // Automatically trigger the Go function if OTP is not required
            }
        }

    }, [companies, setSelectedCompany, Selected]);

    return (
        <>
            <div class="account-pages my-5 pt-sm-5">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-8 col-lg-6 col-xl-5">
                            <div class="card overflow-hidden">
                                <div class="card-body pt-0">
                                    <div className="p-3">
                                        <h4 className="text-muted font-size-18 mb-4 text-center">Mercators</h4>
                                        <p className="text-muted text-center">Hello {user.fullName}, Select a company to continue!</p>

                                        <div className="user-thumb text-center mb-4">
                                            <select
                                                onChange={(e) => setSelectedCompany(e.target.value)}
                                                className="form-control"
                                                value={selectedCompany}
                                            >
                                                <option defaultValue>-- Select a company -- </option>
                                                {companies.map((c) => (
                                                    <option key={c.companyId} value={c.companyId}>{c.companyName}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <Modal show={showOTPModal} onHide={handleCloseShowOTPModal}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>OTP Verification
                                        </Modal.Title>
                                    </Modal.Header>

                                    <Modal.Body>
                                        <div className="row">
                                            <div className="col-12">
                                                <label>An OTP code is sent to your phone number {userPhoneNumber}</label>
                                                <div className="input-group mb-3">
                                                    {/* <span className="input-group-text">{currency.currencySuffix}</span> */}
                                                    <input className="form-control"
                                                        type="text"
                                                        placeholder="Enter OTP code"
                                                        value={otp}
                                                        onChange={handleOTPChange}>
                                                    </input>
                                                </div>
                                            </div>
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>

                                        <button onClick={(e) => SendOTP()} className="btn btn-success">
                                            Resend OTP
                                        </button>

                                        <button className="btn btn-secondary" onClick={handleCloseShowOTPModal}>
                                            Close
                                        </button>

                                        <button onClick={(e) => Selected(e)} className="btn btn-success">
                                            Go
                                        </button>
                                    </Modal.Footer>
                                </Modal>
                            </div>
                            <div class="mt-5 text-center">
                                © <script>document.write(new Date().getFullYear())</script>2024 Mercators <span class="d-none d-sm-inline-block"> - Developed By: Mercator Team.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default SelectCompany